import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ViewEncapsulation, ElementRef } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { StepIndicatorModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { AccordionComponent, AccordionListComponent } from 'lib/ng2-sapmp/src/ui-components/accordion';
import { SignupService } from './../shared/providers/signup.service';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { AppModel, SignUpInputModel, SignUpOutputModel, SignUpModel, ProfileModel } from './../shared/models/signup.models';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { SIGNUPDATA } from 'config';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html

@Component({
  selector: 'app-applications',
  styleUrls: ['./applications.component.scss'],
  templateUrl: './applications.component.html',
  providers: [SignupService],
  encapsulation: ViewEncapsulation.None
})
export class ApplicationsComponent implements OnInit, AfterViewInit {

  eventEmit: any;
  modalClass: string;
  gridOptions: GridOptionsModel;
  stepIndicators: StepIndicatorModel[];
  stepSessionName: string;
  defaultAppsName: any;
  appPackegeTitle: string;
  appAccordianTitle = '';
  showPopup: boolean;
  showEachApp: boolean;
  appPopup: ConfirmModalPopupModel;
  eachAppPopup: ConfirmModalPopupModel;
  learnMoreModelPopupText: string;
  profileName: string;
  appModel: AppModel;
  isAppPackageSelected: boolean;
  signupInputData: SignUpInputModel;
  signupOutputData: SignUpOutputModel;
  selectedAppId: Array<any>;
  ProfileModel: ProfileModel;
  applicationData: any;
  appList: any;
  initialSignup: false;
  showError: boolean;
  notSelected: boolean;
  errorMessage: string;
  authenticatepage: boolean;
  isDefaultProfile: boolean;
  emmProductCode: any;
  toggleLine: boolean;
  selectedAppListFiltered: boolean = false;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private pageloaderService: PageLoaderService, private el: ElementRef,
    private stepindicatorService: StepIndicatorService, private signupService: SignupService,
    private utilityService: UtilityService, private changeDetectionRef: ChangeDetectorRef,
    private http: HttpClient) {

    this.pageloaderService.setPageLoaderStatus(false);

    const signupData = this.signupService.getSignupModel();
    if (signupData) {
      this.signupInputData = signupData.inputModel;
      this.signupOutputData = signupData.outputModel;
      this.initialSignup = signupData.initialSignup;
      this.authenticatepage = true;
    } else {
      this.authenticatepage = false;
      this.router.navigate(['/signup/accounts']);
    }
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    console.log('Applications page start time => ' + new Date().getTime());
    if (!this.authenticatepage) {
      return;
    }
    this.toggleLine = false;
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    this.showPopup = false;
    this.showEachApp = false;
    this.learnMoreModelPopupText = '';
    this.defaultAppsName = '';
    this.appModel = new AppModel();
    this.selectedAppId = [];
    this.ProfileModel = new ProfileModel();
    this.applicationData = {};
    this.applicationData.config = SIGNUPDATA.ApplicationPage;
    this.errorMessage = this.applicationData.errorMessage;
    this.appList = [];
    this.isAppPackageSelected = true;

    // this.signupService.fetchJSON(this.utilityService.getEnvConfig().contentUrl.signup.applications).
    //   subscribe(respobj => {
        this.applicationData.content =  this.activatedRoute.snapshot.data.pageData.signupapplications;
        this.isDefaultProfile = this.signupOutputData.profile.defaultProfile;
        if (this.signupInputData.appList.length) {
          this.initGrid();
        } else {
          this.getAppList();
        }
      // });
       this.signupService.createPageLoadProperties('APPLICATIONS', 'Applications');
  }

  ngAfterViewInit() {
    console.log('Applications page end time => ' + new Date().getTime());
  }

  handleError(type, error?) {
    if (type === 'select') {
      this.notSelected = true;
    } else {
    this.showError = true;
    this.errorMessage = this.applicationData.content.errorMessages[type];
    this.pageloaderService.setPageLoaderStatus(true);
    }
  }

  /* add two columns in single row */
  callBackAppNameCellTemplate(element, row, field, currentElem, type) {
    if (type === 'template') {
      // return `<a tabindex="0" aria-label="Opens a modal dialog."class="app-name">${row.appName}</a><p>${row.shortDesc}</p>`;
      return `<p>${row.shortDesc}</p>`;
    } else if (type.target.classList.contains('app-name')) {
      currentElem.onDataChange.emit({ data: row, type: 'initModal' });
    }
  }

  getAppList() {
     this.emmProductCode = JSON.parse(sessionStorage.getItem('manage-product')).emmProductCode;
    this.signupService.getAppList(this.emmProductCode).
      subscribe(respobj => {
        console.log('Application API response time => ' + new Date().getTime());
        this.signupInputData.appList = respobj.Apps;
        this.initGrid();
      }, error => {
        this.handleError('application', error);
      });
  }

  initGrid() {
    const options = new GridOptionsModel();
    options.enableFiltering = true;
    options.enableSorting = true;
    options.multiSelect = true;
    options.ariaLabel= "Select all applications";
    const pagination = {
      recordsPerPage: 8,
      currentPage: 1,
      isServerSide: false,
      totalRecords: this.signupInputData.appList.length
    };

    options.callbacks = { callBackAppNameCellTemplate: this.callBackAppNameCellTemplate };

    const defaultAppsNameList = [];
    for (let i = 0; i < this.signupInputData.appList.length; i++) {
      if (this.signupInputData.profileList[0].applications.indexOf(this.signupInputData.appList[i].appId) !== -1) {
        defaultAppsNameList.push(this.signupInputData.appList[i].appName);
        this.signupInputData.appList[i].default = true;
      } else {
        this.signupInputData.appList[i].default = false;
      }
    }

    this.checkSetupStatus(this.signupInputData.appList); /* check initial setup or revised setup */

    this.defaultAppsName = defaultAppsNameList;

    options.Paginations = pagination;
    options.gridData = this.signupInputData.appList;    
    options.columnDefinitions = this.applicationData.config.columnDefinitions;
    this.gridOptions = options;
    this.appList = [{
      id: 1, isActive: false, category: this.appAccordianTitle, content: '',
      ariaLabel: this.applicationData.content.accordionAriaLabel
    }];
   
    this.pageloaderService.setPageLoaderStatus(true);
  }

  removeBottomLine(){
    this.toggleLine = !this.toggleLine;
    if(this.signupInputData.appList.length <= 8){
      if(this.toggleLine){
      this.el.nativeElement.getElementsByClassName('accordion')[0].style.border="0px";
      }
      else{
      this.el.nativeElement.getElementsByClassName('accordion')[0].style.borderBottom='1px solid #d2d2d2'; 
      }
    }
  }

  /* check initial setup or revised setup */
  checkSetupStatus(respobj) {
    if (this.isDefaultProfile) {
      for (let i = 0; i < respobj.length; i++) {
        if (respobj[i].default === true) {
          respobj[i].selected = true;
        }
        this.appPackegeTitle = this.applicationData.content.initialFlowPackageLabel;
        this.appAccordianTitle = this.applicationData.content.initialFlowAccordionTitle;
      }
    } else {
      for (let j = 0; j < this.signupInputData.appList.length; j++) {
        this.signupInputData.appList[j].selected =
          this.signupOutputData.profile.applications.indexOf(this.signupInputData.appList[j].appId) !== -1;
      }
      this.profileName = this.signupOutputData.profile.profileName;
      this.appPackegeTitle = this.applicationData.content.revisedFlowPackageLabel.replace('<profileName>', this.profileName);
      this.applicationData.content.revisedFlow = this.applicationData.content.revisedFlow.replace('<profileName>', this.profileName);
      this.appAccordianTitle = this.applicationData.content.revisedFlowAccordionTitle;
      this.isAppPackageSelected = this.isDefaultAppsSelected(this.signupInputData.appList);
    }
  }


  initAppModal(app) {

    const popupHeading = app === undefined ? 'Standard business apps' : app.appName;
    const popupContent = app === undefined ? this.applicationData.appPackageDescription : `<p>${app.longDesc}</p>`;

    this.appPopup = new ConfirmModalPopupModel();
    this.appPopup.modalMessage = popupContent;
    this.appPopup.modalSubHeader = '';
    this.appPopup.modalHeader = popupHeading;
    this.appPopup.confirmButtonMessage = 'OK';
    this.appPopup.confirmButtonAccessibilityText = 'OK.';
    this.appPopup.showCancelButton = false;
    this.modalClass = 'modal-lg applications-modal';
    this.eventEmit = document.activeElement;
    this.showPopup = true;
    this.signupService.createPageLoadProperties('APPLICATIONSMODAL', 'Applications');

  }

  onRowClick(action) {
    if (action.type === 'initModal') {
      this.initAppModal(action.data);
    } else {
      this.signupOutputData.profile.applications = this.selectedAppList();
      this.isAppPackageSelected = this.isDefaultAppsSelected(action.griddata);
    }
  }

  onAppPackSelect() {
    this.isAppPackageSelected = !this.isAppPackageSelected;
    for (let i = 0; i < this.signupInputData.appList.length; i++) {
      this.signupInputData.appList[i].selected = this.signupInputData.appList[i].default && this.isAppPackageSelected;
    }
    if (this.isAppPackageSelected === true)
      this.el.nativeElement.getElementsByClassName('application-list-selector')[0].checked = false;
    this.signupOutputData.profile.applications = this.selectedAppList();
  }

  closePopup() {
    this.showPopup = false;
    this.signupService.createPageLoadProperties('APPLICATIONS', 'Applications');

  }

  /* check if default app selected all together if mean will select app package checkbox automatically */
  isDefaultAppsSelected(gridData) {
    if (gridData && gridData.length > 0) {
      const defaultAppList = gridData.filter(d => d.default);
      const selectedDefaultAppList = defaultAppList.filter(d => d.selected);
      return defaultAppList.length === selectedDefaultAppList.length &&
        selectedDefaultAppList.length === this.signupOutputData.profile.applications.length;
    } else {
      return false;
    }
  }

  selectedAppList() {
    const tmpAppList = [];
    this.signupInputData.appList.filter(item => item.selected === true).forEach(item => tmpAppList.push(item.appId));
    return tmpAppList;
  }

  continueToNext(event) {
    // if(this.signupOutputData.profile.applications.length > 0){
    this.selectedAppListFiltered === false ? 
                this.signupOutputData.profile.applications = this.selectedAppList() : null;
    event.preventDefault();
    this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
    this.router.navigate(['/signup/startdate']);
  }

  navigate() {
    this.router.navigate(['/faq']);
  }

  backToPrevious(event) {
    event.preventDefault();
    this.router.navigate(['/signup/settings']);
  }
}
